import HeroSection from './components/HeroSection';
import FeaturedArtists from './components/FeaturedArtists';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <HeroSection />
      <FeaturedArtists />
      <AboutSection />
      <ServicesSection />
      <TestimonialsSection />
      <CTASection />
    </>
  );
}